(() => {
  // KAIROS_POPUP_EXTERNAL_BOOTSTRAP_20260826
  const boot = () => {
    const template = document.querySelector('[data-kairos-email-popup-template]');
    if (!document.querySelector('[data-kairos-email-popup]') && template) {
      document.body.insertAdjacentHTML('beforeend', template.innerHTML);
    }
    const instances = [...document.querySelectorAll('[data-kairos-email-popup]')];
    instances.slice(1).forEach((instance) => instance.remove());
    const popup = instances[0];
    if (!popup || popup.dataset.initialized === 'true') return;
    popup.dataset.initialized = 'true';

    const card = popup.querySelector('.kairos-email-popup__card');
    const email = popup.querySelector("input[type='email']");
    const sessionCookie = popup.dataset.kairosPopupCookie || 'kairos_popup_session_closed_v2';
    let previousFocus = null;
    let closeTimer = null;
    const sessionClosed = () => document.cookie.split('; ').some((row) => row.startsWith(`${sessionCookie}=`));
    const closeForSession = () => { document.cookie = `${sessionCookie}=true; Path=/; SameSite=Lax`; };
    const consumeOfferPopupRequest = () => {
      try {
        const offer = sessionStorage.getItem('kairos_force_offer_popup');
        if (offer !== 'ExclusiveKairos15') return false;
        sessionStorage.removeItem('kairos_force_offer_popup');
        return true;
      } catch (error) {
        return false;
      }
    };
    const reveal = ({ force = false } = {}) => {
      if (!force && sessionClosed()) return;
      previousFocus = document.activeElement;
      clearTimeout(closeTimer);
      popup.hidden = false;
      requestAnimationFrame(() => popup.classList.add('is-visible'));
      setTimeout(() => (!popup.hidden && popup.classList.contains('is-visible')) && card?.focus({ preventScroll: true }), 190);
    };
    const dismiss = () => {
      if (popup.hidden) return;
      closeForSession();
      popup.classList.remove('is-visible');
      closeTimer = setTimeout(() => {
        popup.hidden = true;
        previousFocus?.focus?.();
      }, 180);
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('a[href="#kairosEmailPopupForm"]');
      if (!trigger) return;
      event.preventDefault();
      reveal({ force: true });
    });
    popup.querySelectorAll('[data-kairos-popup-dismiss]').forEach((button) => button.addEventListener('click', dismiss));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) dismiss();
    });

    if (popup.querySelector('.kairos-email-popup__success')) {
      closeForSession();
      card?.classList.add('is-success');
      reveal({ force: true });
      return;
    }
    if (location.hash === '#kairosEmailPopupForm') {
      reveal({ force: true });
      return;
    }
    if (consumeOfferPopupRequest()) {
      reveal({ force: true });
      return;
    }
    if (popup.dataset.kairosPopupAutoReveal !== 'false' && !sessionClosed()) {
      reveal();
      closeForSession();
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
